($ => {

    if ($('.faq-accordion-block-component').length === 0) {
        return;
    }

    console.log('FAQ Accordion JS loaded');

    $('.faq-accordion-item', '.faq-accordion-block-component').on('click', '.question', function () {
        $(this).toggleClass('opened');
        $(this).next('.answer').slideToggle(300);
    });

})(jQuery);